import React from 'react';
import Button from '@paperstac/ui/lib/Button';
import Box from '@paperstac/ui/lib/Box';
import Link from '@paperstac/ui/lib/Link';
import { INTEGRATIONS } from '@paperstac/routes/lib/webRoutes';
import UnstyledButton from '@paperstac/ui/lib/UnstyledButton';
import Image from '@paperstac/ui/lib/Image';
import Heading from '@paperstac/ui/lib/Heading';
import { getIntegrationLogo, getIntegrationName } from '../IntegrationsPage/IntegrationsPageProvider';

const SelectServicerIntegration = React.memo(({ servicerIntegrations, setSelectedIntegration, setShowImporter }) => {
  return (
    <>
      <Box fontSize={3} mb={3}>
        {!servicerIntegrations.length ? 'You do not have any servicer integrations.' : 'Choose an integration...'}
      </Box>
      {servicerIntegrations.map((integration) => (
        <IntegrationButton
          key={integration.id}
          onClick={() => setSelectedIntegration(integration.id)}
          title={integration.title}
          type={integration.type}
        />
      ))}
      <Box my={5}>
        <Button as={Link} href={INTEGRATIONS} variant={!servicerIntegrations.length ? 'primary' : 'default'}>
          {!servicerIntegrations.length ? 'Create Integration' : 'Add Another Integration'}
        </Button>{' '}
        <Button onClick={() => setShowImporter(false)}>Cancel</Button>
      </Box>
    </>
  );
});

SelectServicerIntegration.propTypes = {};

SelectServicerIntegration.defaultProps = {};

SelectServicerIntegration.displayName = 'SelectServicerIntegration';

export default SelectServicerIntegration;

const IntegrationButton = ({ onClick, title, type }) => {
  return (
    <UnstyledButton
      onClick={onClick}
      sx={{
        display: 'flex',
        bg: 'white',
        borderRadius: 'corner',
        my: 4,
        p: 3,
        width: '100%',
        maxWidth: 400,
        border: 'default',
        borderWidth: '3px',
        '&:hover': {
          bg: 'highlight',
          borderColor: 'secondary',
        },
      }}
    >
      <Box mr={3}>
        <Image src={getIntegrationLogo(type)} size={56} borderRadius="corner" sx={{ display: 'block' }} />
      </Box>
      <Box sx={{ flex: '1 1 0' }}>
        <Heading as="h3" fontSize={3} mb={2}>
          {getIntegrationName(type)}
        </Heading>
        <Box my={1}>{title}</Box>
      </Box>
    </UnstyledButton>
  );
};
